<template>
  <v-dialog
    :value="value"
    :content-class="freeMode ? 'edit-drawer' : 'edit-drawer--fix-width'"
    @input="onClick"
    absolute
    :persistent="persistent"
    transition="slide-x-reverse-transition"
  >
    <v-card class="edit-drawer__content">
      <div v-if="withHeader" class="edit-drawer__header-wrapper">
        <div class="edit-drawer__header">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="showGoBackBtn" class="mr-2 go-back-btn" size="18" @click="goBack" v-bind="attrs" v-on="on"
                >mdi-arrow-left</v-icon
              >
            </template>
            <span>{{ Lang.goBack }}</span>
          </v-tooltip>
          <slot name="header" :title="title">
            <h1 class="edit-drawer__title">{{ title }}</h1>
          </slot>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="edit-drawer__close action-icon"
                icon
                @click="$emit('input', false)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="content-medium">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>{{ closeButtonTooltip || Lang.close }}</span>
          </v-tooltip>
        </div>
      </div>

      <div class="edit-drawer__content-wrapper">
        <slot />
      </div>

      <div v-if="withFooter" class="edit-drawer__footer-wrapper">
        <slot name="footer" />
      </div>
      <SpinnerLoader v-if="isLoading" />
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";
import { mapMutations } from "vuex";

import SpinnerLoader from "@/components/loaders/SpinnerLoader.vue";
import Lang from "@/lang";

export default Vue.extend({
  name: "EditDrawer",

  components: {
    SpinnerLoader,
  },

  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
    value: Boolean,
    freeMode: Boolean,
    withHeader: Boolean,
    withFooter: Boolean,
    title: String,
    showGoBackBtn: {
      default: false,
      type: Boolean,
    },
    closeButtonTooltip: String,
    isLoading: Boolean,
  },

  data() {
    return {
      drawer: true,
      Lang,
    };
  },

  methods: {
    ...mapMutations("pageEdit", ["updateShowDrawerConfig"]),

    onClick(val: boolean): void {
      this.$emit("input", val);
    },

    goBack(): void {
      this.$emit("goBack");
    },
  },
});
</script>

<style scoped lang="scss">
@import "@/scss/theme.scss";
@import "@/scss/custom_variables.scss";

.edit-drawer {
  &__header-wrapper {
    padding-bottom: $space-small;
    background: inherit;
    z-index: 1;
  }

  &__header {
    display: flex;
    align-items: center;
    padding-bottom: $space-small;
    font-size: 20px;
    font-weight: 600;
    border-radius: 0 !important;
  }

  &__footer-wrapper {
    display: flex;
    padding-top: $space-small;
  }

  &__content-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    overflow-y: auto;
    height: 100%;
  }

  &__title {
    margin: 0;
    flex-grow: 1;
  }

  &__content {
    background: var(--v-primary-base) !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    padding: $space-normal;
  }
}

.v-dialog__content {
  justify-content: flex-end;
  ::v-deep {
    .edit-drawer {
      max-width: calc(100% - $menu-width);
    }
    .edit-drawer--fix-width {
      width: $drawer-fix-width;
      height: 100%;
    }
  }
}

.go-back-btn {
  cursor: pointer;
}
</style>
